module.exports = __webpack_public_path__ + "static/media/speakingBg.31baa3e8.jpg";